import { makeModuleStateSelector } from "@client/content/selectors";
import { createShallowEqualSelector } from "@client/selectors";
import { type UploadEndpointInfo } from "@common/components/Media/Upload/types";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type MemberHelpdesk } from "./types";

export const localStateSelector = makeModuleStateSelector<MemberHelpdesk.AppState>(defaultState, previewState);

export const makeItemsSelector = () => {
  return createSelector([localStateSelector], (localState) => localState.tickets);
};

export const makeUploadInfoSelector = (withSubpath: boolean) => {
  return createShallowEqualSelector(
    [localStateSelector],
    (localState): UploadEndpointInfo => ({
      maxSizeMb: 2,
      location: "TicketAttachments",
      isAttachment: true,
      subPath: withSubpath ? `/commentAttachments/${localState.showingDetailId}` : undefined
    })
  );
};
